import type { Palette, Theme } from "@mui/material";
import type { ActionsDrawerVariant } from "web_myplann/Infrastructure/Themes/Colors";

type ActionsDrawerRowColors = {
	content: string | undefined;
	icon: string;
};

type Args = {
	palette: Palette;
	variantConfig: Theme["actionsDrawer"][ActionsDrawerVariant];
	isDisabled: boolean;
	isDestructive: boolean;
};

export const getActionsDrawerRowColors = ({
	palette,
	variantConfig,
	isDisabled,
	isDestructive,
}: Args): ActionsDrawerRowColors => {
	if (isDisabled) {
		return { content: palette.grey[400], icon: palette.grey[300] };
	}

	if (isDestructive) {
		return {
			content: variantConfig.destructiveColor,
			icon: variantConfig.destructiveColor,
		};
	}

	return { content: undefined, icon: variantConfig.iconColor };
};
